import { Injectable } from '@angular/core';

import { Observable, from as fromPromise } from 'rxjs';

import { NbAuthResult } from '@nebular/auth/services/auth-result';
import { NbPasswordAuthStrategy } from '@nebular/auth';


@Injectable()
export class NbEmailPassOAuthProvider extends NbPasswordAuthStrategy {
}
